;(function(commonjs){
  // Blacklist common values.
  var BLACKLIST = [
      "00000000000"
    , "11111111111"
    , "22222222222"
    , "33333333333"
    , "44444444444"
    , "55555555555"
    , "66666666666"
    , "77777777777"
    , "88888888888"
    , "99999999999"
    , "12345678909"
  ];

  function createMapReducePolyfills() {
    Array.prototype.map = function (callback, thisArg) {

        var T, A, k;

        if (this == null) {     
            throw new TypeError(' this is null or not defined');
        }

        // 1. Let O be the result of calling ToObject passing the |this| 
        //    value as the argument.
        var O = Object(this);

        // 2. Let lenValue be the result of calling the Get internal 
        //    method of O with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. If IsCallable(callback) is false, throw a TypeError exception.
        // See: http://es5.github.com/#x9.11
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }

        // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 1) {
            T = thisArg;
        }

        // 6. Let A be a new array created as if by the expression new Array(len) 
        //    where Array is the standard built-in constructor with that name and 
        //    len is the value of len.
        A = new Array(len);

        // 7. Let k be 0
        k = 0;

        // 8. Repeat, while k < len
        while (k < len) {

            var kValue, mappedValue;

            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the HasProperty internal 
            //    method of O with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            if (k in O) {

                // i. Let kValue be the result of calling the Get internal 
                //    method of O with argument Pk.
                kValue = O[k];

                // ii. Let mappedValue be the result of calling the Call internal 
                //     method of callback with T as the this value and argument 
                //     list containing kValue, k, and O.
                mappedValue = callback.call(T, kValue, k, O);

                // iii. Call the DefineOwnProperty internal method of A with arguments
                // Pk, Property Descriptor
                // { Value: mappedValue,
                //   Writable: true,
                //   Enumerable: true,
                //   Configurable: true },
                // and false.

                // In browsers that support Object.defineProperty, use the following:
                // Object.defineProperty(A, k, {
                //   value: mappedValue,
                //   writable: true,
                //   enumerable: true,
                //   configurable: true
                // });

                // For best browser support, use the following:
                A[k] = mappedValue;
            }
            // d. Increase k by 1.
            k++;
        }

        // 9. return A
        return A;
    };
    Array.prototype.reduce = function (callback /*, initialValue*/) {
        'use strict';
        if (this == null) {
            throw new TypeError('Array.prototype.reduce called on null or undefined');
        }
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }
        var t = Object(this), len = t.length >>> 0, k = 0, value;
        if (arguments.length == 2) {
            value = arguments[1];
        } else {
            while (k < len && !k in t) {
                k++;
            }
            if (k >= len) {
                throw new TypeError('Reduce of empty array with no initial value');
            }
            value = t[k++];
        }
        for (; k < len; k++) {
            if (k in t) {
                value = callback(value, t[k], k, t);
            }
        }
        return value;
    };
  }

  var verifierDigit = function (numbers) {
    if (!Array.prototype.map)
        createMapReducePolyfills();

    numbers = numbers.split("").map(function(number){ return parseInt(number, 10); });

    var modulus = numbers.length + 1;

    var multiplied = numbers.map(function(number, index) {
      return number * (modulus - index);
    });

    var mod = multiplied.reduce(function(buffer, number){
      return buffer + number;
    }) % 11;

    return (mod < 2 ? 0 : 11 - mod);
  };

  var CPFValidation = {};

  CPFValidation.format = function(number) {
    return this.strip(number).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  };

  CPFValidation.strip = function(number) {
    return (number || "").toString().replace(/[^\d]/g, "");
  };

  CPFValidation.isValid = function(number) {
    var stripped = this.strip(number);

    // CPF must be defined
    if (!stripped) { return false; }

    // CPF must have 11 chars
    if (stripped.length !== 11) { return false; }

    // CPF can't be blacklisted
    if (BLACKLIST.indexOf(stripped) >= 0) { return false; }

    var numbers = stripped.substr(0, 9);
    numbers += verifierDigit(numbers);
    numbers += verifierDigit(numbers);

    return numbers.slice(-2) === stripped.slice(-2);
  };

  CPFValidation.generate = function(formatted) {
    var numbers = "";

    for (var i = 0; i < 9; i++) {
      numbers += Math.floor(Math.random() * 9);
    }

    numbers += verifierDigit(numbers);
    numbers += verifierDigit(numbers);

    return (formatted ? this.format(numbers) : numbers);
  };

  if (commonjs) {
    module.exports = CPFValidation;
  } else {
    window.CPFValidation = CPFValidation;
  }

    // CNPJ Validation

  function validarCNPJ(cnpj) {

      var cnpj, tamanho, numeros, digitos, soma, pos, resultado;

      cnpj = cnpj ? cnpj.replace(/[^\d]+/g, '') : '';

      if (cnpj == '') return false;

      if (cnpj.length != 14)
          return false;

      // Elimina CNPJs invalidos conhecidos
      if (cnpj == "00000000000000" ||
          cnpj == "11111111111111" ||
          cnpj == "22222222222222" ||
          cnpj == "33333333333333" ||
          cnpj == "44444444444444" ||
          cnpj == "55555555555555" ||
          cnpj == "66666666666666" ||
          cnpj == "77777777777777" ||
          cnpj == "88888888888888" ||
          cnpj == "99999999999999")
          return false;

      // Valida DVs
      tamanho = cnpj.length - 2
      numeros = cnpj.substring(0, tamanho);
      digitos = cnpj.substring(tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (var i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
          return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (var i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
          return false;

      return true;

  }

  if (!window.CNPJValidation)
      window.CNPJValidation = { isValid: validarCNPJ };

})(typeof(exports) !== "undefined");

(function () {
    'use strict';
    
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function (OldValue, NewValue) {
            var returnValue = this;

            if (!NewValue)
                NewValue = "";

            while (returnValue.indexOf(OldValue) >= 0) {
                returnValue = returnValue.replace(OldValue, NewValue);
            }
            return returnValue.toString();
        };
    }

    window.EmailValidator = {
        validate: function (email) {
            var EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            return EMAIL_REGEXP.test(email);
        }
    };

    var Cmc7Validator = {
        validate: function (typedValue) {
            if (typedValue === undefined || typedValue === null) {
                return false;
            }
            typedValue = typedValue.replace(/\s|\*/g, "");
            if (!typedValue) {
                return false;
            }

            var pieces = {
                firstPiece: typedValue.substr(0, 7)
              , secondPiece: typedValue.substr(8, 10)
              , thirdPiece: typedValue.substr(19, 10)
            };


            var digits = {
                firstDigit: parseInt(typedValue.substr(7, 1))
              , secondDigit: parseInt(typedValue.substr(18, 1))
              , thirdDigit: parseInt(typedValue.substr(29, 1))
            };

            var calculatedDigits = {
                firstDigit: this.module10(pieces.firstPiece)
              , secondDigit: this.module10(pieces.secondPiece)
              , thirdDigit: this.module10(pieces.thirdPiece)
            };

            if ((calculatedDigits.secondDigit != digits.firstDigit)
              || (calculatedDigits.firstDigit != digits.secondDigit)
              || (calculatedDigits.thirdDigit != digits.thirdDigit)) {
                return false;
            }
            return true;
        }
          , module10: function (str) {
              if (str === undefined || str === null) {
                  return 0;
              }
              var size = str.length - 1;
              var result = 0;
              var weight = 2;
              var total = 0;

              for (var i = size; i >= 0; i--) {
                  total = str.substr(i, 1) * weight;
                  if (total > 9) {
                      result = result + 1 + (total - 10);
                  } else {
                      result = result + total;
                  }
                  if (weight == 1) {
                      weight = 2;
                  } else {
                      weight = 1;
                  }
              }
              var dv = 10 - this.mod(result, 10);
              if (dv == 10) {
                  dv = 0;
              }
              return dv;
          }
          , mod: function (dividend, divisor) {
              return Math.round(dividend - (Math.floor(dividend / divisor) * divisor));
          }
    };

    var StringMask = (function () {
        var tokens = {
            '0': { pattern: /\d/, _default: '0' },
            '9': { pattern: /\d/, optional: true },
            '#': { pattern: /\d/, optional: true, recursive: true },
            'S': { pattern: /[a-zA-Z]/ },
            '$': { escape: true }
        };


        var isEscaped = function (pattern, pos) {
            var count = 0;
            var i = pos - 1;
            var token = { escape: true };
            while (i >= 0 && token && token.escape) {
                token = tokens[pattern.charAt(i)];
                count += token && token.escape ? 1 : 0;
                i--;
            }
            return count > 0 && count % 2 === 1;
        };
        var calcOptionalNumbersToUse = function (pattern, value) {
            var numbersInP = pattern.replace(/[^0]/g, '').length;
            var numbersInV = value.replace(/[^\d]/g, '').length;
            return numbersInV - numbersInP;
        };
        var concatChar = function (text, character, options) {
            if (options.reverse) return character + text;
            return text + character;
        };
        var hasMoreTokens = function (pattern, pos, inc) {
            var pc = pattern.charAt(pos);
            var token = tokens[pc];
            if (pc === '') return false;
            return token && !token.escape ? true : hasMoreTokens(pattern, pos + inc, inc);
        };
        var insertChar = function (text, char, position) {
            var t = text.split('');
            t.splice(position >= 0 ? position : 0, 0, char);
            return t.join('');
        };
        var StringMask = function (pattern, opt) {
            this.options = opt || {};
            this.options = {
                reverse: this.options.reverse || false,
                usedefaults: this.options.usedefaults || this.options.reverse
            };
            this.pattern = pattern;

            StringMask.prototype.process = function proccess(value) {
                if (!value) return '';
                value = value + '';
                var pattern2 = this.pattern;
                var valid = true;
                var formatted = '';
                var valuePos = this.options.reverse ? value.length - 1 : 0;
                var optionalNumbersToUse = calcOptionalNumbersToUse(pattern2, value);
                var escapeNext = false;
                var recursive = [];
                var inRecursiveMode = false;

                var steps = {
                    start: this.options.reverse ? pattern2.length - 1 : 0,
                    end: this.options.reverse ? -1 : pattern2.length,
                    inc: this.options.reverse ? -1 : 1
                };

                var continueCondition = function (options) {
                    if (!inRecursiveMode && hasMoreTokens(pattern2, i, steps.inc)) {
                        return true;
                    } else if (!inRecursiveMode) {
                        inRecursiveMode = recursive.length > 0;
                    }

                    if (inRecursiveMode) {
                        var pc = recursive.shift();
                        recursive.push(pc);
                        if (options.reverse && valuePos >= 0) {
                            i++;
                            pattern2 = insertChar(pattern2, pc, i);
                            return true;
                        } else if (!options.reverse && valuePos < value.length) {
                            pattern2 = insertChar(pattern2, pc, i);
                            return true;
                        }
                    }
                    return i < pattern2.length && i >= 0;
                };

                for (var i = steps.start; continueCondition(this.options) ; i = i + steps.inc) {
                    var pc = pattern2.charAt(i);
                    var vc = value.charAt(valuePos);
                    var token = tokens[pc];
                    if (!inRecursiveMode || vc) {
                        if (this.options.reverse && isEscaped(pattern2, i)) {
                            formatted = concatChar(formatted, pc, this.options);
                            i = i + steps.inc;
                            continue;
                        } else if (!this.options.reverse && escapeNext) {
                            formatted = concatChar(formatted, pc, this.options);
                            escapeNext = false;
                            continue;
                        } else if (!this.options.reverse && token && token.escape) {
                            escapeNext = true;
                            continue;
                        }
                    }

                    if (!inRecursiveMode && token && token.recursive) {
                        recursive.push(pc);
                    } else if (inRecursiveMode && !vc) {
                        if (!token || !token.recursive) formatted = concatChar(formatted, pc, this.options);
                        continue;
                    } else if (recursive.length > 0 && token && !token.recursive) {
                        // Recursive tokens most be the last tokens of the pattern
                        valid = false;
                        continue;
                    } else if (!inRecursiveMode && recursive.length > 0 && !vc) {
                        continue;
                    }

                    if (!token) {
                        formatted = concatChar(formatted, pc, this.options);
                        if (!inRecursiveMode && recursive.length) {
                            recursive.push(pc);
                        }
                    } else if (token.optional) {
                        if (token.pattern.test(vc) && optionalNumbersToUse) {
                            formatted = concatChar(formatted, vc, this.options);
                            valuePos = valuePos + steps.inc;
                            optionalNumbersToUse--;
                        } else if (recursive.length > 0 && vc) {
                            valid = false;
                            break;
                        }
                    } else if (token.pattern.test(vc)) {
                        formatted = concatChar(formatted, vc, this.options);
                        valuePos = valuePos + steps.inc;
                    } else if (!vc && token._default && this.options.usedefaults) {
                        formatted = concatChar(formatted, token._default, this.options);
                    } else {
                        valid = false;
                        break;
                    }
                }

                return { result: formatted, valid: valid };
            };

            StringMask.prototype.apply = function (value) {
                return this.process(value).result;
            };

            StringMask.prototype.validate = function (value) {
                return this.process(value).valid;
            };
        };

        StringMask.process = function (value, pattern, options) {
            return new StringMask(pattern, options).process(value);
        };

        StringMask.apply = function (value, pattern, options) {
            return new StringMask(pattern, options).apply(value);
        };

        StringMask.validate = function (value, pattern, options) {
            return new StringMask(pattern, options).validate(value);
        };

        return StringMask;
    }());

    function validateMinValue(minValue, value) {
        var value = parseInt(value), minValue = parseInt(minValue);
        return value >= minValue;
    }

    function validateMaxValue(maxValue, value) {
        var value = +value, maxValue = +maxValue;
        return value <= maxValue;
    }

    // TODO: replace app with your module name
    var app = angular.module('validations', []);
    
    app.directive('radioName', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            priority: 1,
            require: ['ngModel'],
            link: function (scope, iElement, iAttrs, ctrls) {
                var targetForm = $parse(iAttrs.radioName)(scope);
                var modelCtrl = ctrls[0];
                modelCtrl.$name = iAttrs.name;
                delete targetForm[modelCtrl.$name];
                targetForm.$addControl(modelCtrl);
            }
        };
    }]);

    app.directive('telMask', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            link: function (scope, element, attrs) {
                let modelConfig = attrs.telMask && attrs.telMask.split(":");
                $(element).on("blur", setMask).blur(setMask);
                $(element).on("focus", resetMask).focus(resetMask);

                function resetMask() {
                    attrs.$set('uiMask', '');
                };

                function setMask() {
                    if ($(element).val().replace('-', '').length >= 9){
                        attrs.$set('uiMask', '99999-9999');
                        if (modelConfig)
                            $timeout(() => $parse(modelConfig[0]).assign(scope, modelConfig[1]), 0);
                    }
                    else
                        attrs.$set('uiMask', '9999-9999');
                };
            }
        };

    }]);

    app.directive('integersOnly', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                $(element).keypress(function (key) {
                    if (key.charCode != 0 && (key.charCode < 48 || key.charCode > 57))
                        return false;
                });
            }
        };
    });

    app.directive('integersSeparatedList', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                $(element).keypress(function (key) {
                    if (key.charCode != 0 && key.charCode !=59 && (key.charCode < 48 || key.charCode > 57))
                        return false;
                });
            }
        };
    });

    app.directive('priceCharCodes', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                $(element).keypress(function (key) {
                    if (key.charCode == 44)
                        return true;
                    else if (key.charCode < 48 || key.charCode > 57)
                        return false;
                });
            }
        };
    });

    app.directive('lettersOnly', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                $(element).keypress(function (key) {
                    if (key.charCode > 48 && key.charCode < 57)
                        return false;
                });
            }
        };
    });

    app.directive('lettersOnlyNoSpecial', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                $(element).keypress(function (key) {
                    var verify = true
                    if (!(key.charCode >= 65 && key.charCode <= 90)
                        && !(key.charCode >= 97 && key.charCode <= 122)
                        && !(key.charCode == 32)
                        )
                        return false;
                });
            }
        };
    });

    app.directive('validateEmail', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var EMAIL_REGEXP = /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

                var validationTypes = {
                    onStart: function (ctrl) {
                        return validateEmail(ctrl.$viewValue);
                    }
                }

                if (attrs.validateEmail) {
                    var options = JSON.parse(attrs.validateEmail);

                    for (var opt in options)
                        validationTypes[opt] && validationTypes[opt](ctrl);
                }

                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue) {
                        return validateEmail(viewValue);
                    }
                    else {
                        ctrl.$setValidity('email', true);
                        ctrl.$setValidity('emailValidate', true);
                        return viewValue;
                    }
                });

                function validateEmail(viewValue) {
                    if (EmailValidator.validate(viewValue)) {
                        ctrl.$setValidity('email', true);
                        ctrl.$setValidity('emailValidate', true);
                        return viewValue;
                    } else {
                        ctrl.$setValidity('email', false);
                        ctrl.$setValidity('emailValidate', false);
                        return viewValue;
                    }
                };

            }
        };
    });
    
    app.directive('onEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.onEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    });

    app.directive('validateMultipleEmails', function () {
        var EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i;

        function validateAll(ctrl, validatorName, value) {
            var validity = ctrl.$isEmpty(value) || value.split(';').every(
                function (email) {
                    return EMAIL_REGEXP.test(email.trim());
                }
            );

            ctrl.$setValidity(validatorName, validity);
            return validity ? value : undefined;
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function postLink(scope, elem, attrs, modelCtrl) {
                function multipleEmailsValidator(value) {
                    return validateAll(modelCtrl, 'multipleEmails', value);
                }

                modelCtrl.$formatters.push(multipleEmailsValidator);
                modelCtrl.$parsers.push(multipleEmailsValidator);
            }
        };
    });

    app.directive('validateDate', ['$timeout', function ($timeout) {
        var currentDate = new Date(), viewValue;

        currentDate.setHours(0, 0, 0, 0);

        function validateGreaterDate(ctrl, date, compareDate) {
            ctrl.$setValidity('greater', date <= (compareDate || currentDate));
            ctrl.$setValidity('invalid', date <= (compareDate || currentDate));
        }

        function validateLessDate(ctrl, date, compareDate) {
            ctrl.$setValidity('less', date >= (compareDate || currentDate));
            ctrl.$setValidity('invalid', date >= (compareDate || currentDate));
        }

        function validateRangeDate(ctrl, date, minDays, maxDays) {
            ctrl.$setValidity('range', currentDate.addDays(minDays) <= date && date <= currentDate.addDays(maxDays));
        }

        return {
            require: 'ngModel',
            priority: -2,
            link: function (scope, element, attrs, ctrl) {

                var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:19[2-9])?\d{4})$/, ISO_DATE_REGEXP = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;

                var customValidate = scope.$eval(attrs.customValidate);
                
                var validationTypes = attrs.validateDate.split(',');
                
                function dateViewValue (view) {
                    viewValue = view;
                    
                    if (viewValue == undefined || viewValue == ""){
                        $timeout(function(){
                            if (attrs.required){
                                ctrl.$setValidity('invalid', false);
                                return viewValue;
                            }
                            else {
                                ctrl.$setValidity('invalid', true);
                                return viewValue;
                            }
                        }, 0);
                    }
                    else {
                        if (viewValue.length == 2)
                            $(element).val(viewValue + '/');

                        if (viewValue.length == 5)
                            $(element).val(viewValue + '/');

                        ctrl.$setValidity('greater', true);
                        ctrl.$setValidity('less', true);
                        ctrl.$setValidity('invalid', true);

                        if (DATE_REGEXP.test(viewValue) && viewValue.length == 10) {
                            testDate(viewValue);
                        } 
                        else if (ISO_DATE_REGEXP.test(viewValue)) {
                            return getFormattedDate(testDate(new Date(viewValue)));
                        }
                        else {
                            ctrl.$setValidity('invalid', false);
                            ctrl.$setValidity('less', true);
                            ctrl.$setValidity('greater', true);
                        }

                        return !attrs.strDate && viewValue.length == 10 && getDateType(viewValue).toISOString() || viewValue;
                    }
                    
                    return viewValue;
                }
                
                function getCompareDate(type) {
                    var compareModel = validationTypes.find(t => t.indexOf(type) >= 0).split(":")[1];'';
                    var dateModel = compareModel && scope.$eval(compareModel);
                    
                    if (dateModel){
                        return typeof dateModel == "string" && getDateType(dateModel) || dateModel;
                    }
                    else {
                        return undefined;
                    }
                };
                
                function getFormattedDate(stringDate) {
                    return stringDate.split('T')[0].split('-').reverse().join('/');
                };
                
                function getDateType(dateString){
                    return dateString.split('/')[2] ? 
                        new Date(dateString.split('/')[2], dateString.split('/')[1] - 1, dateString.split('/')[0]) :
                        new Date(dateString);
                };

                function testDate(date) {
                    var viewValueDate = (date && typeof date != "string") ? date : getDateType(viewValue);

                    if (typeof customValidate != "undefined")
                        customValidate(ctrl, viewValueDate, currentDate, viewValue);

                    //Por padrão a validação checa se a data é maior do que a atual e retorna um erro se for.
                    if (attrs.validateDate && attrs.validateDate.length) {
                        if (validationTypes.find(t => t.indexOf("greater") >= 0)) {
                            validateGreaterDate(ctrl, viewValueDate, getCompareDate("greater"));
                        }
                        if (validationTypes.find(t => t.indexOf("less") >=0 )) {
                            validateLessDate(ctrl, viewValueDate, getCompareDate("less"));
                        }
                        return viewValue;
                    }
                    
                    return viewValue;
                }
                
                ctrl.$formatters.unshift(dateViewValue);
                ctrl.$parsers.unshift(dateViewValue);
            }
        };
    }]);

    app.directive('validateDatePassport', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/;
                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue == undefined)
                        ctrl.$setValidity('invalid', true);
                    else {
                        if (viewValue.length == 2)
                            $(element).val(viewValue + '/');

                        if (viewValue.length == 5)
                            $(element).val(viewValue + '/');

                        if (DATE_REGEXP.test(viewValue) && viewValue.length == 10) {
                            var currentDate = new Date();
                            var viewValueDate = new Date(viewValue.split('/')[2], viewValue.split('/')[1] - 1, viewValue.split('/')[0]);
                            if (viewValueDate > currentDate) {
                                ctrl.$setValidity('greater', true);
                                ctrl.$setValidity('invalid', true);
                                return viewValue;
                            }
                            else if (attrs.validateDate && attrs.validateDate.indexOf('less') >= 0) {
                                validateLessDate(ctrl, viewValueDate);
                                return viewValue;
                            }
                        }
                        else {
                            ctrl.$setValidity('invalid', false);
                            ctrl.$setValidity('greater', true);
                            return viewValue;
                        }
                    }
                });
            }
        };
    });

    app.directive('validateDriversLicense', ['$parse', '$date', function ($parse, $date) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/;
                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue != undefined) {
                        if (DATE_REGEXP.test(viewValue) && viewValue.length == 10) {
                            var minDriversLicenseMonths = 24;
                            var currentDate = new Date();
                            var driversLicenseDate = new Date(viewValue.split('/')[2], viewValue.split('/')[1] - 1, viewValue.split('/')[0]);
                            var actualDriversLicenseMonths = $date.dateDiff('M', driversLicenseDate, currentDate);

                            if (driversLicenseDate.getDate() > currentDate.getDate())
                                actualDriversLicenseMonths--;
                        }

                        ctrl.$setValidity('invalid', (actualDriversLicenseMonths >= minDriversLicenseMonths));

                        return viewValue;
                    }
                });
            }
        };
    }]);

    app.directive('validateDateAdult', ['$parse', '$date', function ($parse, $date) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/;
                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue != undefined) {
                        if (DATE_REGEXP.test(viewValue) && viewValue.length == 10 && $date.minYear(viewValue.split('/')[2])) {
                            var minAge = 12;

                            if (attrs.validateDateMinAge)
                                minAge = $date.dateValuesToDate($parse(attrs.validateDateMinAge)(scope)) || +attrs.validateDateMinAge;

                            var referenceDate;

                            if (attrs.validateDateAdult)
                                referenceDate = $date.dateValuesToDate($parse(attrs.validateDateAdult)(scope));

                            if (referenceDate == null)
                                referenceDate = new Date();

                            var birthDate = new Date(viewValue.split('/')[2], viewValue.split('/')[1] - 1, viewValue.split('/')[0]);
                            var age = $date.calculateAge(birthDate, referenceDate);
                        }
                        //Na cvc o passageiro é considerado adulto a partir dos 12 anos - OBS: quando tem Hotel, agora o adulto é a partir dos 18 anos.
                        ctrl.$setValidity('invalid', (age >= minAge));

                        return viewValue;
                    }
                });
            }
        };
    }]);

    app.directive('validateDateTeenager', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/;
                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue != undefined) {
                        if (DATE_REGEXP.test(viewValue) && viewValue.length == 10 && $date.minYear(viewValue.split('/')[2])) {
                            var currentDate = new Date();
                            var birthDate = new Date(viewValue.split('/')[2], viewValue.split('/')[1] - 1, viewValue.split('/')[0]);
                            var age = currentDate.getFullYear() - birthDate.getFullYear();

                            if (birthDate.getMonth() < currentDate.getMonth() || (birthDate.getMonth() == currentDate.getMonth() && birthDate.getDate() > currentDate.getDate()))
                                --age;

                            ctrl.$setValidity('invalid', (age >= 12 && age < 18));

                            return viewValue;
                        }
                    }
                });
            }
        };
    });

    app.directive('validateDateChild', ['$parse', '$date', function ($parse, $date) {

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/;
                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue != undefined) {
                        if (DATE_REGEXP.test(viewValue) && viewValue.length == 10 && $date.minYear(viewValue.split('/')[2])) {

                            var maxAge = 12;
                            var minAge = 2;

                            if (attrs.validateDateMinAge)
                                minAge = $date.dateValuesToDate($parse(attrs.validateDateMinAge)(scope)) || +attrs.validateDateMinAge;

                            if (attrs.validateDateMaxAge)
                                maxAge = $date.dateValuesToDate($parse(attrs.validateDateMaxAge)(scope)) || +attrs.validateDateMaxAge;

                            var referenceDate;

                            if (attrs.validateDateChild)
                                referenceDate = $date.dateValuesToDate($parse(attrs.validateDateChild)(scope));


                            if (referenceDate == null)
                                referenceDate = new Date();

                            var birthDate = new Date(viewValue.split('/')[2], viewValue.split('/')[1] - 1, viewValue.split('/')[0]);
                            var age = $date.calculateAge(birthDate, referenceDate);

                            ctrl.$setValidity('invalid', (age >= minAge && age <= maxAge));

                            return viewValue;
                        }
                    }
                });
            }
        };
    }]);

    app.directive('validateDateInfant', ['$parse', '$date', function ($parse, $date) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                var DATE_REGEXP = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/;
                ctrl.$parsers.unshift(function (viewValue) {
                    if (viewValue != undefined) {
                        if (DATE_REGEXP.test(viewValue) && viewValue.length == 10 && $date.minYear(viewValue.split('/')[2])) {
                            var currentDate;
                            var maxAge = 23

                            if (attrs.validateDateInfant)
                                currentDate = $date.dateValuesToDate($parse(attrs.validateDateInfant)(scope));

                            if (attrs.validateDateMaxAge)
                                maxAge = $date.dateValuesToDate($parse(attrs.validateDateMaxAge)(scope)) || +attrs.validateDateMaxAge;

                            var birthDate = new Date(viewValue.split('/')[2], viewValue.split('/')[1] - 1, viewValue.split('/')[0]);
                            var age = $date.dateDiff('M', birthDate, currentDate);

                            if (age == (maxAge + 1) && currentDate.getDate() < birthDate.getDate()) {
                                age = maxAge;
                            }

                            ctrl.$setValidity('invalid', (age <= maxAge));

                            return viewValue;
                        }
                    }
                });
            }
        };
    }]);

    app.directive('ngCnpj', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                    if (CNPJValidation.isValid(newVal) || (!attrs.required && !ctrl.$modelValue)) {
                        ctrl.$setValidity('cnpj', true);
                    }
                    else
                        ctrl.$setValidity('cnpj', false);
                });
            }
        };
    }]);

    app.directive('ngCpf', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                    var isEmpty = !newVal || newVal == "";
                    var isRequired = !!(attrs.ngRequired && $parse(attrs.ngRequired)(scope));
                    
                    if (!isRequired && isEmpty){
                        ctrl.$setValidity('cpf', true);
                    }
                    else if (isRequired && !isEmpty) {
                        ctrl.$setValidity('cpf', CPFValidation.isValid(newVal));
                        ctrl.$setValidity('cpfRequired', true);
                    }
                    else if (!isEmpty) {
                        ctrl.$setValidity('cpf', CPFValidation.isValid(newVal));
                    }
                    else if (isRequired && isEmpty) {
                        ctrl.$setValidity('cpf', false);
                        ctrl.$setValidity('cpfRequired', false);
                    }
                    else
                        ctrl.$setValidity('cpf', CPFValidation.isValid(newVal));
                });
                scope.$watch(function () { return $parse(attrs.ngRequired)(scope); }, function (isRequired) {
                    if (isRequired === true) {
                        ctrl.$setValidity('cpf', CPFValidation.isValid(ctrl.$modelValue));
                        ctrl.$setValidity('cpfRequired', true);
                    } else if (isRequired === false) {
                        ctrl.$setValidity('cpf', true);
                        ctrl.$setValidity('cpfRequired', true);
                    }
                });
            }
        };
    }]);

    app.directive('match', ['$parse', function ($parse) {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                scope.$watch(function () {
                    return $parse(attrs.match)(scope) === ctrl.$modelValue;
                }, function (currentValue) {
                    ctrl.$setValidity('mismatch', currentValue);
                    return currentValue;
                });
            }
        };
    }]);
    
    app.directive('customValidation', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                function validateCustomError(viewValue){
                    $timeout(() => ctrl.$setValidity('customError', $parse(attrs.customValidation)(scope)), 0);
                    return viewValue;
                };
                
                scope.$watch(() => $parse(attrs.customValidation)(scope), (newValue, oldValue) => {
                    ctrl.$setValidity('customError', $parse(attrs.customValidation)(scope));
                });
                
                ctrl.$formatters.unshift(validateCustomError);
                ctrl.$parsers.unshift(validateCustomError);
            }
        };
    }]);

    app.directive('minValueReq', function () {
        return {
            require: 'ngModel',
            priority: 2,
            link: function (scope, elem, attrs, ctrl) {
                ctrl.minValue = attrs.minValueReq;
                scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                    if (validateMinValue(attrs.minValueReq, ctrl.$modelValue)) {
                        ctrl.$setValidity('minValue', true);
                    }
                    else {
                        ctrl.$setValidity('minValue', false);
                    }
                });
            }
        };
    });

    app.directive('graterThen', function () {
        return {
            require: 'ngModel',
            priority: 2,
            link: function (scope, elem, attrs, ctrl) {
                scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                    if (attrs.graterThen && parseFloat(ctrl.$modelValue) > parseFloat(attrs.graterThen)) {
                        ctrl.$setValidity('graterThen', true);
                    } else {
                        ctrl.$setValidity('graterThen', false);
                    }
                });
            }
        };
    });

    app.directive('compareRange', function () {
        return {
            require: 'ngModel',
            priority: 2,
            link: function (scope, elem, attrs, ctrl) {

                scope.$watch(attrs.ngModel, function (newVal, oldVal,scope,ctrl) {
                    if (newVal != oldVal) {
                        scope.compareFromValue = newVal;
                        if (parseFloat(newVal) < parseFloat(scope.compareToValue)) {
                            ctrl.$setValidity('compareRange', true);
                        } else {
                            ctrl.$setValidity('compareRange', false);
                        }
                    }
                });

                scope.$watch(attrs.compareTo, function (newVal, oldVal, scope,ctrl) {
                    if (newVal != oldVal) {
                        scope.compareToValue = newVal;
                        if (parseFloat(newVal) > parseFloat(scope.compareFromValue)) {
                            ctrl.$setValidity('compareRange', true);
                        } else {
                            ctrl.$setValidity('compareRange', false);
                        }
                    }
                });
            }
        };
    });

    app.directive('maxValueReq', function () {
        return {
            require: 'ngModel',
            priority: 2,
            link: function (scope, elem, attrs, ctrl) {
                ctrl.maxValue = attrs.maxValueReq;
                scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                    ctrl.$setValidity('maxValue', !!validateMaxValue(attrs.maxValueReq, ctrl.$modelValue))
                });

                scope.$watch(function () { return attrs.maxValueReq; }, function (newVal, oldVal) {
                    ctrl.$setValidity('maxValue', !!validateMaxValue(attrs.maxValueReq, ctrl.$modelValue))
                });
            }
        };
    });

    app.directive('validateCheckboxGroup', ['$parse', '$string', '$timeout', function ($parse, $string, $timeout) {
        return {
            priority: 2,
            link: function (scope, element, attrs, ctrl) {
                var outerScope = scope;
                if (attrs.waitFor) {
                    scope.$watch(attrs.waitFor, function (attrs) {
                        if (attrs)
                            $timeout(initGroup, 0);
                    });
                }
                else
                    initGroup();

                function initGroup() {
                    var elements = $(element).find('input[type="checkbox"]');
                    var models = [];

                    elements.each(function () {
                        var input = $(this);
                        var modelString = input.attr('ng-model').split('[')[0];
                        modelString = $string.format('{0}[{1}]', modelString, input.val());
                        models.push(modelString);
                        scope.$watch(function () { return $parse(modelString)(scope) }, function (string) {
                            var validateSection = $parse(attrs.validateCheckboxGroup)(outerScope);
                            validateGroup(validateSection);
                        });
                    });

                    scope.$watch('submitted', function (newVal) {
                        var validateSection = $parse(attrs.validateCheckboxGroup)(outerScope);

                        validateGroup(validateSection);
                    });

                    function validateGroup(validateSection) {

                        var checked = [];

                        _.forEach(models, function (model) {
                            if ($parse(model)(scope))
                                checked.push($parse(model)(scope));
                        });

                        validateSection.isValid = checked.length >= parseInt(attrs.minReq) ? true : false;
                    };
                };

            }
        }
    }]);
    
    // Filters 
    
    app.directive('inputCurrency', ["$filter", function($filter) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                $(element).on('blur', function(){
                    $(this).val($filter("currency")(viewValue, "", 1));
                });
            }
        }
    }]);    
    
    app.filter('cpf', function() {
        return function(input) {
            var str = input+ '';
            str = str.replace(/\D/g,'');
            str = str.replace(/(\d{3})(\d)/,"$1.$2");
            str = str.replace(/(\d{3})(\d)/,"$1.$2");
            str = str.replace(/(\d{3})(\d{1,2})$/,"$1-$2");
            return str;
        };
    });    
    
    app.filter('cnpj', function() {
        return function(input) {
            // regex créditos Matheus Biagini de Lima Dias
            var str = input+ '';
                str=str.replace(/\D/g,'');
                str=str.replace(/^(\d{2})(\d)/,'$1.$2');
                str=str.replace(/^(\d{2})\.(\d{3})(\d)/,'$1.$2.$3');
                str=str.replace(/\.(\d{3})(\d)/,'.$1/$2');
                str=str.replace(/(\d{4})(\d)/,'$1-$2');
            return str;
        };
    });    
    
    app.filter('cep', function() {
        return function(input) {
            var str = input+ '';
                str = str.replace(/\D/g,'');
                str=str.replace(/^(\d{2})(\d{3})(\d)/,"$1.$2-$3");
            return str;
        };
    });
    
})();
